import React from "react";
import { bannerImg } from "../../assets/index";

const RightBanner = () => {
  return (
    <div className="w-full lgl:w-1/2 flex justify-center items-center relative">
      {/* Outer rotating ring */}
      <div
        style={{
          position: "absolute",
          width: "420px",
          height: "420px",
          borderRadius: "50%",
          border: "1.5px dashed #ff014f55",
          animation: "spinSlow 18s linear infinite",
        }}
      />
      {/* Inner rotating ring (opposite direction) */}
      <div
        style={{
          position: "absolute",
          width: "340px",
          height: "340px",
          borderRadius: "50%",
          border: "1px dashed #ffffff18",
          animation: "spinSlow 12s linear infinite reverse",
        }}
      />

      {/* Floating tech badge — top right */}
      <div style={badgeStyle("top", "-10px", "right", "-10px")}>
        <span style={dotStyle("#22c55e")} />
        Node.js
      </div>

      {/* Floating tech badge — left */}
      <div style={badgeStyle("left", "20px", "top", "50%", "-50%")}>
        <span style={dotStyle("#3b82f6")} />
        Kubernetes
      </div>

      {/* Floating tech badge — bottom right */}
      <div style={badgeStyle("bottom", "30px", "right", "-10px")}>
        <span style={dotStyle("#f59e0b")} />
        AWS
      </div>

      {/* Floating tech badge — bottom left */}
      <div style={badgeStyle("bottom", "80px", "left", "0px")}>
        <span style={dotStyle("#a855f7")} />
        Docker
      </div>

      {/* Image frame with accent border */}
      <div
        style={{
          position: "relative",
          zIndex: 10,
          width: "280px",
          height: "350px",
          borderRadius: "16px",
          overflow: "hidden",
          border: "2px solid #ff014f33",
          boxShadow: "0 0 40px #ff014f22, 0 0 80px #0000004d",
        }}
      >
        {/* Accent corner top-left */}
        <div style={{
          position: "absolute", top: 0, left: 0,
          width: "40px", height: "40px",
          borderTop: "3px solid #ff014f",
          borderLeft: "3px solid #ff014f",
          borderRadius: "16px 0 0 0",
          zIndex: 20,
        }} />
        {/* Accent corner bottom-right */}
        <div style={{
          position: "absolute", bottom: 0, right: 0,
          width: "40px", height: "40px",
          borderBottom: "3px solid #ff014f",
          borderRight: "3px solid #ff014f",
          borderRadius: "0 0 16px 0",
          zIndex: 20,
        }} />

        <img
          src={bannerImg}
          alt="Biprodas Barai"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "top center",
            display: "block",
          }}
        />

        {/* Bottom gradient overlay with name tag */}
        <div style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          padding: "24px 16px 14px",
          background: "linear-gradient(to top, #000000cc, transparent)",
          zIndex: 15,
        }}>
          <p style={{ color: "#fff", fontWeight: 600, fontSize: "14px", margin: 0 }}>
            Biprodas Barai
          </p>
          <p style={{ color: "#ff014f", fontSize: "12px", margin: "2px 0 0", fontWeight: 400 }}>
            Backend & Platform Engineer
          </p>
        </div>
      </div>

      {/* Experience pill — floats below-right of image */}
      <div style={{
        position: "absolute",
        bottom: "10px",
        right: "calc(50% - 200px)",
        background: "#1e2024",
        border: "1px solid #ff014f44",
        borderRadius: "999px",
        padding: "6px 16px",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        zIndex: 20,
        fontSize: "13px",
        color: "#fff",
        boxShadow: "0 4px 20px #00000066",
      }}>
        <span style={{ color: "#ff014f", fontWeight: 700, fontSize: "15px" }}>2+</span>
        yrs production experience
      </div>

      <style>{`
        @keyframes spinSlow {
          from { transform: rotate(0deg); }
          to   { transform: rotate(360deg); }
        }
        @keyframes floatBadge {
          0%, 100% { transform: translateY(0px); }
          50%       { transform: translateY(-6px); }
        }
      `}</style>
    </div>
  );
};

const badgeStyle = (side1, val1, side2, val2, translateY = "0%") => ({
  position: "absolute",
  [side1]: val1,
  [side2]: val2,
  transform: translateY !== "0%" ? `translateY(${translateY})` : undefined,
  background: "#1e2024ee",
  border: "1px solid #ffffff15",
  borderRadius: "999px",
  padding: "5px 12px 5px 8px",
  display: "flex",
  alignItems: "center",
  gap: "6px",
  fontSize: "12px",
  fontWeight: 500,
  color: "#e2e8f0",
  zIndex: 20,
  animation: "floatBadge 3s ease-in-out infinite",
  backdropFilter: "blur(6px)",
  whiteSpace: "nowrap",
});

const dotStyle = (color) => ({
  width: "8px",
  height: "8px",
  borderRadius: "50%",
  background: color,
  display: "inline-block",
  flexShrink: 0,
});

export default RightBanner;